import {
    AnimationBaseController,
    GameApiBase
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../../Models/GameModel";
import {AnimationContents} from "../../AnimationContents";
import {GameLogic} from "../../../Logic/GameLogic";

import {ButtonController, IButtonControllerOptions} from "../../Common/ButtonController";
import {LocalizationContents} from "../../../LocalizationContents";

export interface IIntroScreenControllerOptions
{
}

export class ExitMenuScreenController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options:IIntroScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("ExitMenuScreenController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.PAUSE_SCREEN_JSON,
            libraryName: "exit_to_menu",
            childControllers: {
                YesButton: {
                    instanceName: "button_yes",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.hideMainMenuContainer();
                            this._gameLogic.showMainMenuContainer();
                        },
                        localKey: LocalizationContents.keys.exit_menu_yes
                    }
                },
                NoButton: {
                    instanceName: "button_no",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.showPauseMenu();
                        },
                        localKey: LocalizationContents.keys.exit_menu_no
                    }
                },
            },
            modelWatch: {
                
            }
        };
    }

    protected onInitialize(): void {
        this.setTextByQuery("txt.exit_menu_text", LocalizationContents.exit_menu_text);
        this.setTextByQuery("txt2.exit_menu_confirm_title", LocalizationContents.exit_menu_confirm_title);
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

